import { Controller } from 'stimulus';

export default class extends Controller {
  closeWindow() {
    if (window.opener) {
      const win = window.open("","_self")
      win.close()
    } else {
      window.history.back()
    }
  }
}